<div
  class="icon-container"
  [style.width.px]="width"
  [style.height.px]="height">
  @if (icon && (iconsLoaded$ | async)) {
    <div
      class="icon"
      [innerHTML]="iconSVG"></div>
  } @else {
    <ppl-loading-ellipsis></ppl-loading-ellipsis>
  }
</div>
